// External libraries
import React from 'react';
import { useStoreState } from '@/store';

// Internal modules
import { isSepaMandateCountry } from '@/lib';
// @ts-expect-error untyped import
import { changeHandler } from '../Form/handlers';
import { OnboardTerms } from '../OnboardTerms';
import { useMountLogging } from '@/lib/reactHooks';
import { SepaContainer } from '@/components/OnboardOptions/StyledComponents';
import { LazySepaMandate } from '@/components/SignupFields/LegalDisclosures/Components';

export const GuestTermsAndLegalDisclosure = (): JSX.Element => {
  useMountLogging('OnboardOptions');

  const fiType = useStoreState(({ ui }) => ui.fiType);
  const isFiTypeBank = fiType === 'bank';
  const hasSepaMandate = isSepaMandateCountry();

  return (
    <div data-testid="guest-terms-and-legal-disclosure">
      <OnboardTerms changeHandler={changeHandler} type="guest" />
      {hasSepaMandate && isFiTypeBank && (
        <SepaContainer>
          <LazySepaMandate changeHandler={changeHandler} />
        </SepaContainer>
      )}
    </div>
  );
};
